import { defineMessages, IntlShape } from "react-intl";

import CumulAccess from "@mapmycustomers/shared/enum/cumul/CumulAccess";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<CumulAccess>({
  [CumulAccess.CAN_EDIT]: {
    id: "cumulAccess.canEdit",
    defaultMessage: "Can edit",
  },
  [CumulAccess.CAN_OWN]: {
    id: "cumulAccess.canOwn",
    defaultMessage: "Can own",
  },
  [CumulAccess.CAN_USE]: {
    id: "cumulAccess.canUse",
    defaultMessage: "Can use",
  },
  [CumulAccess.CAN_VIEW]: {
    id: "cumulAccess.canView",
    defaultMessage: "Can view",
  },
});

const getCumulAccessDisplayName = (intl: IntlShape, cumulAccess: CumulAccess) =>
  getDisplayName(intl, messages, cumulAccess, "CumulAccess");

export default getCumulAccessDisplayName;
